import { Toolbar } from "@mui/material";

function Rules() {
    return (
        <>
            <Toolbar />
            <center>
                <h3>How to Play Mastermind board game?</h3>
            </center>
            <ul>
                <li>At the beginning of each game a four color code will be generated.</li>
                <li>The colors are always chosen from the seven colors in the top row. Duplicates are not allowed.</li>
                <li>The objective is to guess the secret code. You have to guess the colors and put them in the same order as they are in the secret code.</li>
                <li>Choose one color among the seven colors from the top row (blinking color is current color).</li>
                <li>Place it in the circle of current row. After placing four colors, click on the <b>Check</b> button.</li>
                <li>Whenever the check button is clicked Green/Red colors will be displayed in the small four circles which are after the <b>Check</b> button in the following way:
                    <ul>
                        <li><b>Green color:</b>represents one of the colors what you have placed is there in the secret code and it is in correct position as in the secret code.</li>
                        <li><b>Red color</b>:represents one of the colors what you have have placed is there in the secret code but it is not in correct position.</li>
                    </ul>
                </li>
                <li>You have ten chances to guess the correct code, if you exhaust all of them without guessing the code, you lost the game and the secret code will be displayed in the last row.</li>
            </ul>
            <center>
                <h4>Good Luck!!</h4>
            </center>
        </>
    );
}

export default Rules;
